import React from 'react'
import './Service.css';
import Card from '../Card/Card';
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png"
import Resume from './vishal.pdf.pdf';
import {motion} from 'framer-motion';
export default function Service() {
  const transition ={duration: 2, type:'spring'};
  return (
    <div className="Services" id='services'>
        <div className='awesome'>
          <span>My Awesome</span>
          <span>Service</span>
          <span>
          I develop user interfaces, Frontend and

            <br/>
            Web Applications.
          </span>
          <a href={Resume}download>
          <button className='s-button'>Download CV</button>
          </a>
          <div className='blur s-blur1' style={{background:"#ABF1FF94"}}></div>
        </div>

        <div className='cards'>
         <motion.div 
          initial={{ right: "-3rem" }}
          whileInView={{ left: "44rem" }}
          transition={transition}
         >
         <Card
            emoji={HeartEmoji}
            heading={"Design"}
            detail={"Figma, Sketch, Photoshop, Adobe Illustrator, Adobe xd"}
          />
          </motion.div>
          <motion.div
            initial={{ left: "25rem" }}
            whileInView={{ left: "28rem" }}
            transition={transition}
          style={{top:'30%',left:'28rem'}}>
           <Card
            emoji={Glasses}
            heading={"Developer"}
            detail={"Html, Css, JavaScript, React, Nodejs, Express"}
          />
          </motion.div>
          <motion.div 
            initial={{ right: "-3rem" }}
            whileInView={{ left: "44rem" }}
            transition={transition}
          style={{top:'22rem'}}>
          <Card
          emoji={Humble}
          heading={'Miscellaneous'}
          detail={'Android studio, Visual Studio, Unreal Engine, Firebase, Git, Github, Unity'}
          />
          </motion.div> 
          <div
          className="blur s-blur2"
          style={{ background: "var(--purple)",position:'absolute',left:'30%',height:'40rem',width:'70vw' }}
        ></div>
        </div>
    </div>
    
  )
}
